import React from 'react';

import FactoringApprovalPending from './tabs/FactoringApprovalPending';
import FactoringRequests from './tabs/FactoringRequests';

export interface FinanceTabConfig {
  value: string;
  label: string;
  Component: React.ComponentType;
}

export const FINANCE_TABS: FinanceTabConfig[] = [
  {
    value: 'requests',
    label: 'Solicitudes de factoring',
    Component: FactoringRequests,
  },
  {
    value: 'approval-pending',
    label: 'Pendientes de aprobación',
    Component: FactoringApprovalPending,
  },
];

export const FINANCE_TAB_ITEMS = FINANCE_TABS.map(({ value, label }) => ({
  value,
  label,
}));

export const FINANCE_DEFAULT_TAB = FINANCE_TABS[0].value;

export const getTabComponent = (
  value: string,
): React.ComponentType | undefined =>
  FINANCE_TABS.find((tab) => tab.value === value)?.Component;
